<template>
  <div class="mapShow3D">
    <div id="cesiumContainer" class="cesiumContainer"></div>

    <!--加载属性框-->
    <popupcom :popupinfo="popupinfo"></popupcom>
  </div>

</template>

<script>
// 引入Cesium的css
import "cesium/Build/Cesium/Widgets/widgets.css";

/** 属性框 */
import Popup from "./Popup.js";
import "./Popup.css";
import PopupCompent from "./Popup.vue";


import {getFactoryLayer} from "@api/map2d";
import {getPipelineInfo3DByProperty} from "@api/map3d";

export default {
  name: "mapShow3D",
   components:{
      popupcom:PopupCompent,
  },
  data() {
    return {
      baseUrl: this.$store.state.assetsUrl, // 静态资源路径

      popupinfo:null, // 弹出框的信息
    };
  },
  mounted() {
    // this.init();
    this.loadScript(this.baseUrl+'/lib/Cesium/Cesium.js',this.init);
  },
  methods: {
    // 初始化
    init(){
      let protocol=window.location.protocol;
      var tdt={
        tk:"633ab2a001dcfa85f77d445dd7e873c2",
        subdomains:['0','1','2','3','4','5','6','7'],
        initTDT(){
            var imageryProvider=new Cesium.WebMapTileServiceImageryProvider({
                // 电子地图
                url:protocol+"//t{s}.tianditu.gov.cn/DataServer?T=vec_w&x={TileCol}&y={TileRow}&l={TileMatrix}&tk="+this.tk,
                subdomains: this.subdomains,
                maximumLevel:17,
                layer: "tdtVecBasicLayer",
                style: "default",
                format: "image/jpeg",
                tileMatrixSetID: "GoogleMapsCompatible",//使用谷歌的瓦片切片方式
                show: true
            });
            return imageryProvider;
        },
      }
      // 初始化Cesium应用程序
      const viewer = new Cesium.Viewer('cesiumContainer',{
        geocoder:false,
        sceneModePicker:false,
        baseLayerPicker:false,
        navigationHelpButton:false,
        animation:false,
        // creditContainer:"credit",
        timeline:false,
        fullscreenButton:false,
        vrButton:false,
        shouldAnimate: true,
        selectionIndicator:true,
        infoBox:false,
        homeButton:true,
        imageryProvider:tdt.initTDT(),
      });
      // 保存引用
      window.cesiumViewer=viewer;
      // 加载其他图层
      let imageryLayers = viewer.imageryLayers;
      // 初始化天地图注记图层数据源
      let imageryProvider = new Cesium.WebMapTileServiceImageryProvider({
        // 注记
        url:protocol+"//t{s}.tianditu.gov.cn/DataServer?T=cva_w&x={TileCol}&y={TileRow}&l={TileMatrix}&tk="+tdt.tk,
        subdomains: tdt.subdomains,
        layer: "tdtAnnoLayer",
        style: "default",
        format: "image/jpeg",
        tileMatrixSetID: "GoogleMapsCompatible",
        show: false
      });
      // 将图层数据源组织
      let layer = new Cesium.ImageryLayer(imageryProvider);
      // 将图层加入到影像图层容器中
      imageryLayers.add(layer);

      //去掉版权信息
      viewer._cesiumWidget._creditContainer.style.display="none";
      // 创建相机初始位置和朝向
      var initialPosition = new Cesium.Cartesian3.fromDegrees(120.355,30.335,300.0);
      var initialOrientation = new Cesium.HeadingPitchRoll.fromDegrees(0, -90, 0);
      var homeCameraView = {
          destination : initialPosition,
          orientation : {
              heading : initialOrientation.heading,
              pitch : initialOrientation.pitch,
              roll : initialOrientation.roll
          }
      };
      // 设置视图
      viewer.scene.camera.setView(homeCameraView);
      // 增加相机飞行动画参数
      homeCameraView.duration = 2.0;
      homeCameraView.maximumHeight = 2000;
      homeCameraView.pitchAdjustHeight = 2000;
      homeCameraView.endTransform = Cesium.Matrix4.IDENTITY;
      // 重写home按钮功能
      viewer.homeButton.viewModel.command.beforeExecute.addEventListener(function (e) {
          e.cancel = true;
          viewer.scene.camera.flyTo(homeCameraView);
      });

      // 抗锯齿
      viewer.scene.fxaa = true;
      viewer.scene.postProcessStages.fxaa.enabled = true;
      var supportsImageRenderingPixelated = viewer.cesiumWidget._supportsImageRenderingPixelated;
      if (supportsImageRenderingPixelated) {
        var vtxf_dpr = window.devicePixelRatio;
        while (vtxf_dpr >= 2.0) { vtxf_dpr /= 2.0; }
        viewer.resolutionScale = vtxf_dpr;
      }

      // 执行加载模型
      this.addModelLoad();
      // 添加点击函数
      this.addMouseclick();
      // 增加厂区
      this.addFactory();
      // 加载罗盘
      this.loadScript(this.baseUrl+'/lib/Cesium/viewerCesiumNavigationMixin.min.js',this.addCesiumNavigation);
    },
    addModelLoad(){
      let viewer=window.cesiumViewer;
      // 加载管道模型
      let titleUrl=process.env.VUE_APP_RESOURCE;
      var url= titleUrl+"/hdxs/tileset.json?_="+(new Date().getTime());

      let tileset=null;
      // 加载3d管道模型
      tileset = viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
          url:url,  //数据路径  
          maximumScreenSpaceError: 2,        //最大的屏幕空间误差   
          maximumNumberOfLoadedTiles: 1000,  //最大加载瓦片个数
      }));
      tileset.readyPromise.then(function(tileset) {
          console.log("模型加载成功");
          viewer.scene.primitives.add(tileset);

          // 获取三维模型
          var transparentStyle = new Cesium.Cesium3DTileStyle({
              color : "color('red', 0.3)",
              show : true
          });
          tileset.style=transparentStyle;
      }).otherwise(function(error) {
          console.log(error);
      });
      // 跳到模型上
      viewer.zoomTo(tileset); 
    },
    // 增加导航罗盘
    addCesiumNavigation(){
      let viewer=window.cesiumViewer;
      // 增加罗盘
      viewer.extend(Cesium.viewerCesiumNavigationMixin, {});
    },
    // 增加点击函数
    // 鼠标点击事件
    addMouseclick(){
        let viewer=window.cesiumViewer;
        let that=this;
        // HTML overlay for showing feature name on mouseover
        var nameOverlay = document.createElement("div");
        viewer.container.appendChild(nameOverlay);
        nameOverlay.className = "tooltip";

        // Information about the currently selected feature
        var selected = {
            feature: undefined,
            originalColor: new Cesium.Color(),
        };

        // An entity object which will hold info about the currently selected feature for infobox display
        var selectedEntity = new Cesium.Entity();

        // Get default left click handler for when a feature is not picked on left click
        var clickHandler = viewer.screenSpaceEventHandler.getInputAction(
            Cesium.ScreenSpaceEventType.LEFT_CLICK
        );

        // If silhouettes are supported, silhouette features in blue on mouse over and silhouette green on mouse click.
        // If silhouettes are not supported, change the feature color to yellow on mouse over and green on mouse click.
        if (Cesium.PostProcessStageLibrary.isSilhouetteSupported(viewer.scene)) {
            // Silhouettes are supported

            var silhouetteGreen = Cesium.PostProcessStageLibrary.createEdgeDetectionStage();
            silhouetteGreen.uniforms.color = Cesium.Color.LIME;
            silhouetteGreen.uniforms.length = 0.01;
            silhouetteGreen.selected = [];

            viewer.scene.postProcessStages.add(Cesium.PostProcessStageLibrary.createSilhouetteStage([
                    silhouetteGreen,
                ])
            );
            // Silhouette a feature on selection and show metadata in the InfoBox.
            viewer.screenSpaceEventHandler.setInputAction(function onLeftClick(movement) {
                // If a feature was previously selected, undo the highlight
                silhouetteGreen.selected = [];

                // Pick a new feature
                var pickedFeature = viewer.scene.pick(movement.position);
                if (!Cesium.defined(pickedFeature)) {
                    clickHandler(movement);
                    return;
                }

                // Select the feature if it's not already selected
                if (silhouetteGreen.selected[0] === pickedFeature) {
                    return;
                }

                // Save the selected feature's original color
                var highlightedFeature = silhouetteGreen.selected[0];
                // 如果当前选中的图形和高亮的图形相同，择清空选中
                if (pickedFeature === highlightedFeature) {
                    silhouetteGreen.selected = [];
                }else{
                    if(highlightedFeature){
                        highlightedFeature.color=new Cesium.Color('blue', 0.3);
                    }
                }
                // 高亮显示
                pickedFeature.color=new Cesium.Color( 1.0,  0, 0,  1.0);

                // Highlight newly selected feature
                silhouetteGreen.selected = [pickedFeature];
                // 显示属性信息
                that.getPipelineProprety(pickedFeature,movement);
            },
            Cesium.ScreenSpaceEventType.LEFT_CLICK);

            // 赋值
            that.silhouetteGreen=silhouetteGreen;
        } else {
            // Silhouettes are not supported. Instead, change the feature color.

            // Information about the currently highlighted feature
            var highlighted = {
                feature: undefined,
                originalColor: new Cesium.Color(),
            };

            // Color a feature yellow on hover.
            viewer.screenSpaceEventHandler.setInputAction(function onMouseMove(movement) {
                // If a feature was previously highlighted, undo the highlight
                if (Cesium.defined(highlighted.feature)) {
                    highlighted.feature.color = highlighted.originalColor;
                    highlighted.feature = undefined;
                }
                // Pick a new feature
                var pickedFeature = viewer.scene.pick(movement.endPosition);
                if (!Cesium.defined(pickedFeature)) {
                    nameOverlay.style.display = "none";
                    return;
                }
                var name = pickedFeature.getProperty("name");
                if (!Cesium.defined(name)) {
                    name = pickedFeature.getProperty("id");
                }
                // 如果没有名称则不显示
                if(!name){
                    return;
                }

                // A feature was picked, so show it's overlay content
                nameOverlay.style.display = "block";
                nameOverlay.style.bottom =
                viewer.canvas.clientHeight - movement.endPosition.y + "px";
                nameOverlay.style.left = movement.endPosition.x + "px";
                nameOverlay.textContent = name;
                // Highlight the feature if it's not already selected.
                if (pickedFeature !== selected.feature) {
                    highlighted.feature = pickedFeature;
                    Cesium.Color.clone(
                        pickedFeature.color,
                        highlighted.originalColor
                    );
                    pickedFeature.color = Cesium.Color.YELLOW;
                }
            },
            Cesium.ScreenSpaceEventType.MOUSE_MOVE);

            // Color a feature on selection and show metadata in the InfoBox.
            viewer.screenSpaceEventHandler.setInputAction(function onLeftClick(movement) {
                // If a feature was previously selected, undo the highlight
                if (Cesium.defined(selected.feature)) {
                    selected.feature.color = selected.originalColor;
                    selected.feature = undefined;
                }
                // Pick a new feature
                var pickedFeature = viewer.scene.pick(movement.position);
                if (!Cesium.defined(pickedFeature)) {
                    clickHandler(movement);
                    return;
                }
                // Select the feature if it's not already selected
                if (selected.feature === pickedFeature) {
                return;
                }
                selected.feature = pickedFeature;
                // Save the selected feature's original color
                if (pickedFeature === highlighted.feature) {
                    Cesium.Color.clone(
                        highlighted.originalColor,
                        selected.originalColor
                    );
                    highlighted.feature = undefined;
                } else {
                    Cesium.Color.clone(pickedFeature.color, selected.originalColor);
                }
                // 高亮选中对象
                pickedFeature.color = Cesium.Color.LIME;

                // 显示选中内容的属性信息
                var featureName = pickedFeature.getProperty("name");
                viewer.selectedEntity = selectedEntity;

                // 获取经纬度
                let r=that.getCartographic(movement.position);
                let c=Cesium.Cartesian3.fromDegrees(r[0],r[1],r[2]);

                // 创建信息框
                new Popup({
                    viewer:window.cesiumViewer,
                    geometry:c,
                    id:"infopanel",
                    name:featureName,
                    onclose:function(){
                        
                    }
                });
            },
            Cesium.ScreenSpaceEventType.LEFT_CLICK);
        }
    },
    // 获取经纬度
    getCartographic(position) {
        let viewer=window.cesiumViewer;
        var ray = viewer.scene.camera.getPickRay(position);
        var cartesian = null;
        var pickPostion = {};
        var feature = viewer.scene.pick(position);
        if (viewer.scene.pickPositionSupported && Cesium.defined(feature) && feature.content) {
            cartesian = viewer.scene.pickPosition(position);
        } else if (feature instanceof Cesium3DTileFeature) {
            cartesian = viewer.scene.pickPosition(position);
        } else {
            cartesian = viewer.scene.globe.pick(ray, viewer.scene);
        }
        if (cartesian) {
            var cartographic = Cesium.Cartographic.fromCartesian(cartesian); // 结果对象中的值将以弧度表示。
            var longitude = Number(Cesium.Math.toDegrees(cartographic.longitude));
            var latitude = Number(Cesium.Math.toDegrees(cartographic.latitude));
            var height = Number(cartographic.height);
            //pickPostion = { 'longitude': longitude.toFixed(6), 'latitude': latitude.toFixed(6), 'height': height.toFixed(2) };
            pickPostion = [parseFloat(longitude.toFixed(6)),parseFloat(latitude.toFixed(6)),parseFloat(height.toFixed(2))];
        }
        return pickPostion;
    },
    // 点击获取管道的属性信息
    getPipelineProprety(pickedFeature,movement){
        console.log(pickedFeature);
        let that=this;
        // let property="type"; // 查询的属性名称
        // let content=pickedFeature.getProperty("type"); // 查询的属性内容
        let property="name"; // 查询的属性名称
        let content=pickedFeature.getProperty("name"); // 查询的属性内容
        // 请求管道信息
        getPipelineInfo3DByProperty(property,content).then(data=>{
            if(data.status==200){
                let pipe_content=data.content;
                console.log(pipe_content);
                let featureName = pickedFeature.getProperty("name")||pickedFeature.getProperty("id");
                // 获取经纬度
                let r=that.getCartographic(movement.position);
                let c=Cesium.Cartesian3.fromDegrees(r[0],r[1],r[2]);
                // 显示信息
                that.popupinfo=pipe_content;
                // 创建信息框
                new Popup({
                    viewer:window.cesiumViewer,
                    geometry:c,
                    id:"infopanel",
                    name:featureName,
                    close:true,
                    content:document.querySelector(".popup"),
                    onClose:function(){
                        // 取消高亮
                        pickedFeature.color=new Cesium.Color('blue', 0.3);
                        that.silhouetteGreen.selected = [];
                    }
                });
            }
        })
    },
    // 厂区图层
    addFactory(){
        getFactoryLayer().then(data=>{
            // 判断是否数据正常
            if(data&&data.status&&data.status==500){
                return
            }
            let viewer=window.cesiumViewer;
            // 加载模型
            Cesium.GeoJsonDataSource.load(data).then(datasource=>{
                let dataSource=viewer.dataSources;
                dataSource.add(datasource);
                var entities = datasource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    let polygon=entity.polygon;
                    polygon.material=new Cesium.Color(0.12, 0.45, 0.77,0.7); // 设置颜色
                    // 添加标注
                    var polyPositions = polygon.hierarchy.getValue(Cesium.JulianDate.now()).positions;
                    var polyCenter = Cesium.BoundingSphere.fromPoints(polyPositions).center;//中心点
                    polyCenter = Cesium.Ellipsoid.WGS84.scaleToGeodeticSurface(polyCenter);
                    let cartographic = Cesium.Cartographic.fromCartesian(polyCenter, viewer.scene.globe.ellipsoid, new Cesium.Cartographic());
                    // 转换为经纬度
                    let lat = Cesium.Math.toDegrees(cartographic.latitude);
                    let lng = Cesium.Math.toDegrees(cartographic.longitude);
                    let height = cartographic.height;
                    entity.position=Cesium.Cartesian3.fromDegrees(lng, lat,height); // 设置标注的位置
                    entity.label= new Cesium.LabelGraphics({
                        position: Cesium.Cartesian3.fromDegrees(lng, lat,height),
                        text:entity.name,
                        color : Cesium.Color.fromCssColorString('#fff'),
                        font:'normal 32px MicroSoft YaHei',
                        showBackground : false,
                        scale : 0.5,
                        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    });
                    
                }

            });
        });
    },

    // 动态加载script
    loadScript(src, callback) {
        var script = document.createElement('script'),
            head = document.getElementsByTagName('head')[0];
        script.type = 'text/javascript';
        script.charset = 'UTF-8';
        script.src = src;
        if (script.addEventListener) {
            script.addEventListener('load', function () {
                callback();
            }, false);
        } else if (script.attachEvent) {
            script.attachEvent('onreadystatechange', function () {
                var target = window.event.srcElement;
                if (target.readyState == 'loaded') {
                    callback();
                }
            });
        }
        head.appendChild(script);
    },
  }
};
</script>

<style lang='scss'>
.mapShow3D {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: absolute;

  .cesiumContainer{
    width: 100%;
    height: 100%;
    
    .cesium-viewer-toolbar{
      right:35px;
    }

    /*导航条*/
    .cesium-widget-cesiumNavigationContainer{
        position: absolute;
        right: 10px;
        top:-50px;
    }

    .tooltip{
        color:#fff;
        display:none;
        position:absolute;
        bottom: 0;
        left: 0;
        pointer-events:none;
        padding:2px 10px;
        background-color:black;
        border-radius: 3px;
    }

    #navigationDiv{
      .compass{
        top: 90px;
      }
      .navigation-controls{
        top:180px;
      }
      .navigation-controls{
        background: rgba(0,0,0,0.5);
      }


    }
    
  }  
}
</style>